import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";

const DeveloperSection = () => {
    const { colors } = useTheme();
    const sectionRef = useRef(null);
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        let animationFrameId;
        const handleScroll = () => {
            animationFrameId = requestAnimationFrame(() => {
                if (sectionRef.current) {
                    const rect = sectionRef.current.getBoundingClientRect();
                    const visibleY = window.innerHeight - rect.top;
                    if (visibleY > -100 && rect.bottom > 0) {
                        setScrollY(visibleY);
                    }
                }
            });
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        };
    }, []);

    return (
        <section
            ref={sectionRef}
            className="relative py-32 px-6 overflow-hidden"
        >
            <div className="relative max-w-4xl mx-auto">
                <div className="relative flex flex-col items-center group">
                    <div
                        className="w-full relative flex justify-center"
                        style={{ transform: `translateY(${scrollY * -0.05}px)` }}
                    >
                        <div className="w-full aspect-square max-w-sm relative flex items-center justify-center">
                            <img
                                src="https://avatars.githubusercontent.com/u/75479923?v=4"
                                alt="Sawan Sihag"
                                className="relative w-32 h-32 md:w-40 md:h-40 rounded-full object-cover shadow-2xl z-10 hover:scale-105 transition-transform duration-700"
                            />
                        </div>
                    </div>

                    <div
                        className="text-center space-y-6"
                        style={{ transform: `translateY(${scrollY * 0.02}px)` }}
                    >
                        <h2 className={`text-3xl md:text-4xl font-bold tracking-tight ${colors.text}`}>
                            Sawan Sihag
                        </h2>
                        <p className={`text-lg md:text-xl font-light ${colors.textSecondary}`}>
                            AI Engineer & Open Source Developer
                        </p>
                        <div className="flex gap-6 justify-center pt-6">
                            <a href="https://github.com/InvincibleSihag" target="_blank" rel="noopener noreferrer" className={`hover:-translate-y-2 transition-transform duration-300 ${colors.text}`}>
                                <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
                            </a>
                            <a href="https://linkedin.com/in/sawan-sihag-553a4519b/" target="_blank" rel="noopener noreferrer" className={`hover:-translate-y-2 transition-transform duration-300 ${colors.text}`}>
                                <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DeveloperSection;
